const SprintStatusesReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_SPRINT_STATUSES':
            return action.data;
        default:
            return state;
    };
};

export default SprintStatusesReducer;